import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingSystemPages } from "@/data/roofingSystemContent";

const c = roofingSystemPages["torch-down-roofing"];

export const Route = createFileRoute("/services/torch-down-roofing")({
  head: () => ({
    meta: [
      { title: "Torch-Down Roofing Southern California | McKay Roofing & Solar" },
      { name: "description", content: c.heroSubtitle },
      { property: "og:title", content: "Torch-Down Roofing - McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/torch-down-roofing" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});
